"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[450],{

/***/ 22331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "ZP": function() { return /* binding */ CardInfo; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var components_global_parameters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29443);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 165px;\n  background: white;\n  box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.35);\n  border-radius: 5px;\n  gap: 6px;\n  padding: 12px;\n  font-family: JetBrains Mono;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n  text-transform: capitalize;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




function CardInfo(_param) {
    var label = _param.label, percentage = _param.percentage, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label",
        "percentage"
    ]);
    var format = components_global_parameters__WEBPACK_IMPORTED_MODULE_3__/* .percentFormatter.format */ .yE.format;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                children: label.toLowerCase()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Percentage, {
                children: format(percentage)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                children: "mesas escrutadas"
            })
        ]
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d4bfd05f-0"
})(_templateObject());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d4bfd05f-1"
})(_templateObject1());
var Percentage = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(Title).withConfig({
    componentId: "sc-d4bfd05f-2"
})(_templateObject2(), components_global_parameters__WEBPACK_IMPORTED_MODULE_3__/* .colors.decidechileBlue */ .O9.decidechileBlue);
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(Title).withConfig({
    componentId: "sc-d4bfd05f-3"
})(_templateObject3());


/***/ }),

/***/ 32384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CircleGraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./components/2022/plebiscito/AtDecideChile.js
var AtDecideChile = __webpack_require__(67171);
// EXTERNAL MODULE: ./components/global-parameters.js
var global_parameters = __webpack_require__(29443);
;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/CircleGraph/Caption.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: min-content;\n  gap: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: grid;\n  grid: min-content min-content / auto;\n  justify-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 61px;\n  height: 9px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



function Caption(param) {
    var className = param.className, _ranges = param.ranges, ranges = _ranges === void 0 ? [] : _ranges;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: className,
        rangesNumber: ranges.length + 1,
        children: ranges.map(function(param) {
            var color = param.color, label = param.label;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Range, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rectangle, {
                        color: color
                    })
                ]
            }, label);
        })
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1053e2c-0"
})(_templateObject());
var Range = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1053e2c-1"
})(_templateObject1());
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b1053e2c-2"
})(_templateObject2());
var Rectangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1053e2c-3"
})(_templateObject3(), function(param) {
    var color = param.color;
    return color || global_parameters/* colors.colorGrey1 */.O9.colorGrey1;
});

// EXTERNAL MODULE: ./components/2022/plebiscito/CountedTables/CircleGraph/CardInfo.js
var CardInfo = __webpack_require__(22331);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 9 modules
var es_popover = __webpack_require__(66456);
;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/CircleGraph/Circles/ResponsiveCircle.js




function ResponsiveCircle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 37px;\n"
    ]);
    ResponsiveCircle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResponsiveCircle_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  border-radius: 50%;\n  width: 100%;\n  height: auto;\n  padding-top: 100%;\n"
    ]);
    ResponsiveCircle_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ResponsiveCircle_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n  position: absolute;\n  display: flex;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n"
    ]);
    ResponsiveCircle_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



function ResponsiveCircle(_param) {
    var children = _param.children, className = _param.className, color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "color"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveCircle_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
            color: color,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveCircle_Label, {
                children: children
            })
        })
    }));
};
var ResponsiveCircle_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c867d93-0"
})(ResponsiveCircle_templateObject());
var Circle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c867d93-1"
})(ResponsiveCircle_templateObject1(), function(param) {
    var color = param.color;
    return color || global_parameters/* colors.colorGrey1 */.O9.colorGrey1;
});
var ResponsiveCircle_Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c867d93-2"
})(ResponsiveCircle_templateObject2());

// EXTERNAL MODULE: ./components/2022/plebiscito/reportAnalytics.js
var reportAnalytics = __webpack_require__(92949);
;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/CircleGraph/Circles/index.js




function Circles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 3px;\n  max-width: calc(",
        " - 370px);\n  "
    ]);
    Circles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Circles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media(max-width: ",
        "){\n    display: inherit;\n  }\n"
    ]);
    Circles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Circles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    Circles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Circles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inherit;\n  @media(max-width: ",
        "){\n    display: none;\n  }\n"
    ]);
    Circles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







function Circles(param) {
    var _circles = param.circles, circles = _circles === void 0 ? [] : _circles, className = param.className, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, smallCircles = param.smallCircles;
    var sendEvent = function(idx, value) {
        onMouseEnter(idx);
        (0,reportAnalytics/* default */.Z)("escrutada_event", value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Circles_Wrapper, {
        className: className,
        children: circles.map(function(_param, idx) {
            var color = _param.color, label = _param.label, popover = _param.popover, props = (0,_object_without_properties/* default */.Z)(_param, [
                "color",
                "label",
                "popover"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_popover/* default */.Z, {
                            content: popover,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Circles_Circle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                color: color,
                                onMouseEnter: function() {
                                    return onMouseEnter(idx);
                                },
                                onMouseLeave: onMouseLeave,
                                smallCircles: smallCircles
                            }, props), {
                                children: smallCircles ? "" : label
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Circles_Circle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            color: color,
                            onMouseEnter: function() {
                                return sendEvent(idx, props.shortLabel);
                            },
                            onMouseLeave: onMouseLeave
                        }, props), {
                            children: smallCircles ? "" : label
                        }))
                    })
                ]
            }, label);
        })
    });
};
var Circles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a0ccd3a-0"
})(Circles_templateObject(), global_parameters/* spaces.maxContent */.RZ.maxContent);
var PopoverWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a0ccd3a-1"
})(Circles_templateObject1(), global_parameters/* spaces.maxWidth */.RZ.maxWidth);
var Circles_Circle = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveCircle).withConfig({
    componentId: "sc-4a0ccd3a-2"
})(Circles_templateObject2(), function(param) {
    var smallCircles = param.smallCircles;
    return smallCircles && "width: 29px; height: 29px;";
});
var CircleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a0ccd3a-3"
})(Circles_templateObject3(), global_parameters/* spaces.maxWidth */.RZ.maxWidth);

;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/CircleGraph/index.js

function CircleGraph_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display:flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  position: relative;\n"
    ]);
    CircleGraph_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CircleGraph_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  align-self: flex-end;\n"
    ]);
    CircleGraph_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CircleGraph_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: -180px;\n  top: -20px;\n  @media(max-width: ",
        "){\n    display: none;\n  }\n"
    ]);
    CircleGraph_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








function CircleGraph(param) {
    var _circles = param.circles, circles = _circles === void 0 ? [] : _circles, className = param.className, ranges = param.ranges, smallCircles = param.smallCircles;
    var ref = (0,react.useState)(false), sideInfoIndex = ref[0], setSideInfoIndex = ref[1];
    var selectedCircle = circles[sideInfoIndex];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircleGraph_Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circles, {
                circles: circles,
                onMouseEnter: setSideInfoIndex,
                onMouseLeave: function() {
                    return setSideInfoIndex(false);
                },
                smallCircles: smallCircles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleGraph_AtDecideChile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption, {
                ranges: ranges
            }),
            selectedCircle && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideCardInfo, {
                label: selectedCircle.shortLabel,
                percentage: selectedCircle.ratio
            })
        ]
    });
};
var CircleGraph_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83fa15e9-0"
})(CircleGraph_templateObject());
var CircleGraph_AtDecideChile = (0,styled_components_browser_esm/* default */.ZP)(AtDecideChile/* default */.Z).withConfig({
    componentId: "sc-83fa15e9-1"
})(CircleGraph_templateObject1());
var SideCardInfo = (0,styled_components_browser_esm/* default */.ZP)(CardInfo/* default */.ZP).withConfig({
    componentId: "sc-83fa15e9-2"
})(CircleGraph_templateObject2(), global_parameters/* spaces.maxWidth */.RZ.maxWidth);


/***/ }),

/***/ 48029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Timeline_Timeline; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/Timeline/Controls.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  border: none;\n  padding: 1px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function Controls(_param) {
    var onPause = _param.onPause, onPlay = _param.onPlay, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onPause",
        "onPlay"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                onClick: onPlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "Play",
                    height: 12,
                    src: "/images/play.svg",
                    width: 12
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                onClick: onPause,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "Pause",
                    height: 12,
                    src: "/images/pause.svg",
                    width: 12
                })
            })
        ]
    }));
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9469cab-0"
})(_templateObject());
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-e9469cab-1"
})(_templateObject1());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/global-parameters.js
var global_parameters = __webpack_require__(29443);
// EXTERNAL MODULE: ./components/2022/plebiscito/reportAnalytics.js
var reportAnalytics = __webpack_require__(92949);
;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/Timeline/LineGraph.js


function LineGraph_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid: 1fr / repeat(",
        ", min-content 1fr) min-content;\n  width: 100%;\n  align-items: center;\n  justify-items: center;\n  padding: 0 12px;\n"
    ]);
    LineGraph_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LineGraph_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  pointer-events: ",
        ";\n"
    ]);
    LineGraph_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-top: 2px solid ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-size: 12px;\n  width: 1px;\n  cursor: pointer;\n  ",
        ";\n  color: ",
        ";\n  @media(max-width: ",
        "){\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  width: ",
        ";\n  height: ",
        ";\n  border: 2px solid ",
        ";\n  background-color: white;\n  cursor: pointer;\n  ",
        ";\n  @media(max-width: ",
        "){\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





function LineGraph(param) {
    var className = param.className, _current = param.current, current = _current === void 0 ? 0 : _current, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, _lastLabelIdx = param.lastLabelIdx, lastLabelIdx = _lastLabelIdx === void 0 ? 0 : _lastLabelIdx, lastMode = param.lastMode, onChange = param.onChange;
    var mapLabels = (0,_to_consumable_array/* default */.Z)(labels);
    var firstLabel = mapLabels.shift();
    var sendEvent = function(idx, label, type_of_component) {
        onChange(idx);
        (0,reportAnalytics/* default */.Z)("timeline_event", label, type_of_component);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LineGraph_Wrapper, {
        lastMode: lastMode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline, {
            className: className,
            labelsNumber: labels.length,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                    inactive: lastLabelIdx < 0,
                    onClick: function() {
                        return sendEvent(0, firstLabel, "circle");
                    },
                    selected: current === 0
                }),
                mapLabels.map(function(label, idx) {
                    var realIndex = idx + 1;
                    var inactive = realIndex > lastLabelIdx;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Space, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {
                                    inactive: inactive
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                                inactive: inactive,
                                onClick: function() {
                                    return sendEvent(realIndex, label, "circle");
                                },
                                selected: realIndex === current
                            })
                        ]
                    }, label);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    inactive: lastLabelIdx < 0,
                    onClick: function() {
                        return sendEvent(0, firstLabel, "label");
                    },
                    selected: current === 0,
                    children: firstLabel
                }),
                mapLabels.map(function(label, idx) {
                    var realIndex = idx + 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Space, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                inactive: realIndex > lastLabelIdx,
                                onClick: function() {
                                    return sendEvent(realIndex, label, "label");
                                },
                                selected: realIndex === current,
                                children: labels[realIndex]
                            })
                        ]
                    }, label);
                })
            ]
        })
    });
};
var Timeline = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a541b2c-0"
})(LineGraph_templateObject(), function(param) {
    var labelsNumber = param.labelsNumber;
    return labelsNumber - 1;
});
var LineGraph_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a541b2c-1"
})(LineGraph_templateObject1(), function(param) {
    var lastMode = param.lastMode;
    return lastMode ? "none" : "auto";
});
var Space = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a541b2c-2"
})(_templateObject2());
var Line = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a541b2c-3"
})(_templateObject3(), function(param) {
    var inactive = param.inactive;
    return inactive ? global_parameters/* colors.colorGrey12 */.O9.colorGrey12 : global_parameters/* colors.colorGrey1 */.O9.colorGrey1;
});
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a541b2c-4"
})(_templateObject4(), function(param) {
    var inactive = param.inactive;
    return inactive && "pointer-events: none";
}, function(param) {
    var inactive = param.inactive;
    return inactive ? global_parameters/* colors.colorGrey12 */.O9.colorGrey12 : global_parameters/* colors.colorGrey1 */.O9.colorGrey1;
}, global_parameters/* spaces.mobileBreakpoint */.RZ.mobileBreakpoint);
var Circle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a541b2c-5"
})(_templateObject5(), function(param) {
    var selected = param.selected;
    return selected ? "14px" : "8px";
}, function(param) {
    var selected = param.selected;
    return selected ? "14px" : "8px";
}, function(param) {
    var inactive = param.inactive;
    return inactive ? global_parameters/* colors.colorGrey12 */.O9.colorGrey12 : global_parameters/* colors.colorGrey1 */.O9.colorGrey1;
}, function(param) {
    var inactive = param.inactive;
    return inactive && "pointer-events: none";
}, global_parameters/* spaces.mobileBreakpoint */.RZ.mobileBreakpoint, function(param) {
    var selected = param.selected;
    return selected ? "12px" : "6px";
}, function(param) {
    var selected = param.selected;
    return selected ? "12px" : "6px";
});

;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/Timeline/index.js

function Timeline_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n"
    ]);
    Timeline_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Timeline_Timeline(param) {
    var className = param.className, _current = param.current, current = _current === void 0 ? 0 : _current, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, lastLabelIdx = param.lastLabelIdx, lastMode = param.lastMode, onChange = param.onChange, onPause = param.onPause, onPlay = param.onPlay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline_Wrapper, {
        className: className,
        children: [
            !lastMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Controls, {
                onPause: onPause,
                onPlay: onPlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineGraph, {
                current: lastMode ? lastLabelIdx : current,
                labels: labels,
                lastLabelIdx: lastLabelIdx,
                lastMode: lastMode,
                onChange: onChange
            })
        ]
    });
};
var Timeline_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9f10fd3c-0"
})(Timeline_templateObject());


/***/ }),

/***/ 54955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RegionSection_RegionTable; }
});

// UNUSED EXPORTS: RegionTable

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./components/2022/plebiscito/helpers.js
var helpers = __webpack_require__(25735);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/global-parameters.js
var global_parameters = __webpack_require__(29443);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/2022/plebiscito/RegionSection/RegionTable/RegionHeader.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: contents;\n    > * {\n        width: 100%;\n        padding: 2px 10px;\n        border-bottom: 0.5px solid ",
        ";\n    }\n    @media(max-width: ",
        "){\n        > :nth-child(n + 4n+1){\n            border-right: 0.5px solid ",
        ";\n        }\n        &:nth-child(1){\n            box-shadow: -3px 19px 17px 0px ",
        ";\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    cursor: pointer;\n    text-transform: uppercase;\n\n    /* Disable select */\n    user-select: none; /* supported by Chrome and Opera */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 0.5px solid ",
        ";\n  position: sticky;\n    top: 0;\n    left: 0;\n    background-color: ",
        ";\n    z-index: 1;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column:  2 / ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: flex-end;\n    padding-right: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: flex-start;\n    padding-left: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    justify-content: flex-start;\n    position: sticky;\n    top: 0;\n    left: 0;\n    background-color: ",
        ";\n    z-index: 1;\n    @media(max-width: ",
        "){\n        padding-left: 0px;\n        > :nth-child(1){\n            display:none;\n        }\n        grid: 1fr / 1fr;\n        box-shadow: -3px 19px 17px 0px ",
        ";\n        border-right: 0.5px solid ",
        ";\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid: 1fr;\n    align-items: center;\n    justify-content: center;\n    padding-left: 2px;\n    width: 7px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var RegionHeader = function(param) {
    var className = param.className, currentSort = param.currentSort, firstColumnLabel = param.firstColumnLabel, headers = param.headers, onSort = param.onSort, selectedUnit = param.selectedUnit, territoryImage = param.territoryImage, title = param.title;
    var isCurrentSort = function(param) {
        var currentSort = param.currentSort, electionKey = param.electionKey, field = param.field;
        var currentElectionKey = currentSort.electionKey, currentField = currentSort.field, currentOrder = currentSort.order;
        var isSameElection = electionKey === currentElectionKey;
        var isSameField = currentField === field;
        if (isSameElection && isSameField) {
            return currentOrder;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlancItem, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparadorHeader, {
                        headers: headers,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Zone, {
                onClick: function() {
                    return onSort({
                        field: "order"
                    });
                },
                territoryImage: territoryImage,
                children: firstColumnLabel
            }),
            headers.map(function(param) {
                var electionKey = param.electionKey, optionA = param.optionA, optionB = param.optionB, shortLabel = param.shortLabel;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftLabel, {
                            onClick: function() {
                                return onSort({
                                    field: "results.".concat(electionKey, ".optionA.").concat(selectedUnit)
                                });
                            },
                            order: isCurrentSort({
                                currentSort: currentSort,
                                electionKey: electionKey,
                                field: optionA.field
                            }),
                            children: optionA.shortLabel || optionA.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: shortLabel
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightLabel, {
                            onClick: function() {
                                return onSort({
                                    field: "results.".concat(electionKey, ".optionB.").concat(selectedUnit)
                                });
                            },
                            order: isCurrentSort({
                                currentSort: currentSort,
                                electionKey: electionKey,
                                field: optionB.field
                            }),
                            children: optionB.shortLabel || optionB.label
                        })
                    ]
                }, electionKey);
            })
        ]
    });
};
var Label = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(LabelWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortUpDown, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        alt: "sort_up",
                        height: "7px",
                        src: "/images/sorter_up.svg",
                        width: "7px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        alt: "sort_down",
                        height: "7px",
                        src: "/images/sorter_down.svg",
                        width: "7px"
                    })
                ]
            })
        ]
    }));
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52a37cd4-0"
})(_templateObject(), global_parameters/* colors.colorBlack */.O9.colorBlack, global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint, global_parameters/* colors.colorBlack */.O9.colorBlack, global_parameters/* colors.colorBlack */.O9.colorBlack);
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52a37cd4-1"
})(_templateObject1());
var BlancItem = (0,styled_components_browser_esm/* default */.ZP)(LabelWrapper).withConfig({
    componentId: "sc-52a37cd4-2"
})(_templateObject2(), global_parameters/* colors.colorWhite */.O9.colorWhite, global_parameters/* colors.colorWhite */.O9.colorWhite);
var ComparadorHeader = (0,styled_components_browser_esm/* default */.ZP)(LabelWrapper).withConfig({
    componentId: "sc-52a37cd4-3"
})(_templateObject3(), function(param) {
    var headers = param.headers;
    return headers.length * 3 + 2;
});
var LeftLabel = (0,styled_components_browser_esm/* default */.ZP)(Label).withConfig({
    componentId: "sc-52a37cd4-4"
})(_templateObject4());
var RightLabel = (0,styled_components_browser_esm/* default */.ZP)(Label).withConfig({
    componentId: "sc-52a37cd4-5"
})(_templateObject5());
var Zone = (0,styled_components_browser_esm/* default */.ZP)(Label).withConfig({
    componentId: "sc-52a37cd4-6"
})(_templateObject6(), function(param) {
    var territoryImage = param.territoryImage;
    return territoryImage && "padding-left: 70px;";
}, global_parameters/* colors.colorWhite */.O9.colorWhite, global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint, global_parameters/* colors.colorBlack */.O9.colorBlack, global_parameters/* colors.colorBlack */.O9.colorBlack);
var SortUpDown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52a37cd4-7"
})(_templateObject7());
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
    componentId: "sc-52a37cd4-8"
})(_templateObject8());
/* harmony default export */ var RegionTable_RegionHeader = (RegionHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/2022/plebiscito/ElectionBar.js
var ElectionBar = __webpack_require__(91889);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/2022/plebiscito/reportAnalytics.js
var reportAnalytics = __webpack_require__(92949);
;// CONCATENATED MODULE: ./components/2022/plebiscito/RegionSection/RegionTable/RegionItems.js




function RegionItems_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    ",
        " {\n        ",
        "{\n            height: 25.82px;\n        }\n    }\n"
    ]);
    RegionItems_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegionItems_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1/-1;\n  min-height: 30px;\n  background-color: white;\n  z-index: 1;\n"
    ]);
    RegionItems_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegionItems_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: contents;\n    width: 100%;\n    > * {\n        padding: 10px 0;\n        height: 100%;\n        border-bottom: 0.5px solid ",
        ";\n    }\n    :hover{\n        > * {\n            background: ",
        ";\n        }\n    }\n    @media(max-width: ",
        "){\n        > :nth-child(3n+1){\n            border-right: 0.5px solid ",
        ";\n        }\n        > :nth-child(1){\n            box-shadow: -3px 19px 17px 0px ",
        ";\n        }\n    }\n"
    ]);
    RegionItems_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegionItems_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RegionItems_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RegionItems_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    RegionItems_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RegionItems_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    height: 100%;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 17px;\n    justify-content: flex-end;\n    flex-direction: ",
        ";\n    gap: 20px;\n"
    ]);
    RegionItems_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RegionItems_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid: 1fr / max-content 1fr;\n    text-align: start;\n    cursor: pointer;\n    position: sticky;\n    top: 0;\n    left: 0;\n    background-color: ",
        ";\n    z-index: 1;\n    gap: 20px;\n    @media(max-width: ",
        "){\n        grid: 1fr / 1fr;\n        min-width: 130px;\n        ",
        "{\n            display:none;\n        }\n    }\n"
    ]);
    RegionItems_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RegionItems_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    user-select: none;\n    font-size: 13px;\n    line-height: 17px;\n    align-items: center;\n    text-decoration-line: underline;\n    text-transform: capitalize;\n"
    ]);
    RegionItems_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var RegionItems = function(param) {
    var className = param.className, href = param.href, icon = param.icon, label = param.label, onClick = param.onClick, results = param.results, rowItem = param.rowItem, selected = param.selected, territoryImage = param.territoryImage;
    var pathname = (0,router.useRouter)().pathname;
    var getChartResults = function(result) {
        return [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result.optionA), {
                vote_fraction: result.optionA.porcentaje
            }),
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result.optionB), {
                vote_fraction: result.optionB.porcentaje
            })
        ];
    };
    var sendSignal = function(label, pathname, href) {
        (0,reportAnalytics/* default */.Z)("region_navegation", label, pathname, href);
        if (onClick) {
            onClick();
        }
    };
    var Zone = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ZoneWrapper, {
        onClick: function() {
            return sendSignal(label, "".concat(pathname), "".concat(href));
        },
        children: [
            territoryImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: label,
                    height: "40px",
                    src: icon,
                    width: "40px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionLabel, {
                children: label
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegionItems_Wrapper, {
                className: className,
                children: [
                    onClick ? Zone : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat(pathname).concat(href),
                        passHref: true,
                        children: Zone
                    }),
                    Object.entries(results).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), electionKey = _param[0], result = _param[1];
                        var chartResult = getChartResults(result);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionItems_Label, {
                                    align: "row",
                                    children: chartResult[0].label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectionChart, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionItems_ElectionBar, {
                                        results: chartResult,
                                        totalVotes: result.totalVotes
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionItems_Label, {
                                    align: "row-reverse",
                                    children: chartResult[1].label
                                })
                            ]
                        }, electionKey + label);
                    })
                ]
            }),
            selected && rowItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItem, {
                children: rowItem
            })
        ]
    });
};
var RegionItems_ElectionBar = (0,styled_components_browser_esm/* default */.ZP)(ElectionBar/* default */.ZP).withConfig({
    componentId: "sc-e9627a91-0"
})(RegionItems_templateObject(), ElectionBar/* ChartBar */.BM, ElectionBar/* ChartBarCandidate */.bT);
var RowItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9627a91-1"
})(RegionItems_templateObject1());
var RegionItems_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9627a91-2"
})(RegionItems_templateObject2(), global_parameters/* colors.colorGrey15 */.O9.colorGrey15, global_parameters/* colors.colorGrey10 */.O9.colorGrey10, global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint, global_parameters/* colors.colorBlack */.O9.colorBlack, global_parameters/* colors.colorBlack */.O9.colorBlack);
var ImageBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9627a91-3"
})(RegionItems_templateObject3());
var ElectionChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9627a91-4"
})(RegionItems_templateObject4());
var RegionItems_Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9627a91-5"
})(RegionItems_templateObject5(), function(props) {
    return props.align;
});
var ZoneWrapper = (0,styled_components_browser_esm/* default */.ZP)(RegionItems_Label).withConfig({
    componentId: "sc-e9627a91-6"
})(RegionItems_templateObject6(), global_parameters/* colors.colorWhite */.O9.colorWhite, global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint, ImageBox);
var RegionLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9627a91-7"
})(RegionItems_templateObject7());
/* harmony default export */ var RegionTable_RegionItems = (RegionItems);

;// CONCATENATED MODULE: ./components/2022/plebiscito/RegionSection/RegionTable/index.js

function RegionTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    overflow-x: auto;\n    width: 100%;\n"
    ]);
    RegionTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegionTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    width: 100%;\n    align-items: center;\n    min-width: ",
        ";\n    grid: 1fr / 1fr repeat(",
        ", 1fr 2fr 1fr);\n"
    ]);
    RegionTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var RegionTable = function(param) {
    var className = param.className, data = param.data, _firstColumnLabel = param.firstColumnLabel, firstColumnLabel = _firstColumnLabel === void 0 ? "REGI\xd3N" : _firstColumnLabel, onSort = param.onSort, selectedElection = param.selectedElection, selectedUnit = param.selectedUnit, territoryImage = param.territoryImage;
    var ref;
    var rowNumber = data.length;
    if (!rowNumber) return null;
    var selectedElections = Object.keys((ref = data[0]) === null || ref === void 0 ? void 0 : ref.results).map(function(electionKey) {
        return helpers/* ELECTIONS_PROPERTIES */.N5[electionKey];
    });
    var numberOfElections = selectedElections.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTable_Wrapper, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table, {
            numberOfElections: numberOfElections,
            selectedElection: selectedElection,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTable_RegionHeader, {
                    currentSort: function() {
                        return console.log("currentSort");
                    },
                    firstColumnLabel: firstColumnLabel,
                    headers: selectedElections,
                    onSort: onSort,
                    selectedUnit: selectedUnit,
                    territoryImage: territoryImage
                }),
                data.map(function(param) {
                    var href = param.href, icon = param.icon, key = param.key, label = param.label, onClick = param.onClick, results = param.results, rowItem = param.rowItem, selected = param.selected, shortLabel = param.shortLabel;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTable_RegionItems, {
                        href: href,
                        icon: icon,
                        label: shortLabel || label,
                        onClick: onClick,
                        results: results,
                        rowItem: rowItem,
                        selected: selected,
                        territoryImage: territoryImage
                    }, key);
                })
            ]
        })
    });
};
var RegionTable_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5533331b-0"
})(RegionTable_templateObject());
var Table = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5533331b-1"
})(RegionTable_templateObject1(), global_parameters/* spaces.mobileBreakpoint */.RZ.mobileBreakpoint, function(param) {
    var numberOfElections = param.numberOfElections;
    return numberOfElections;
});
/* harmony default export */ var RegionSection_RegionTable = (RegionTable);


/***/ }),

/***/ 14979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RegionSection_SearchFilter; }
});

// UNUSED EXPORTS: SearchFilter

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./components/2022/plebiscito/FilterInput.js
var FilterInput = __webpack_require__(81996);
// EXTERNAL MODULE: ./components/2022/plebiscito/StyledButton.js
var StyledButton = __webpack_require__(77988);
;// CONCATENATED MODULE: ./components/2022/plebiscito/MultiSelectionButton.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid: 1fr / repeat(",
        ", 1fr);\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    min-width: default;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var MultiSelectionButton = function(param) {
    var className = param.className, options = param.options, selectedOption = param.selectedOption, setSelectedOption = param.setSelectedOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: className,
        options: options,
        children: options.map(function(op) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton/* default */.Z, {
                disabledOption: true,
                key_: op.key,
                label: op.label,
                selectedOption: selectedOption,
                setSelectedOption: setSelectedOption
            }, op.key);
        })
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6556fff0-0"
})(_templateObject(), function(props) {
    return props.options.length;
});
/* harmony default export */ var plebiscito_MultiSelectionButton = (MultiSelectionButton);

// EXTERNAL MODULE: ./components/global-parameters.js
var global_parameters = __webpack_require__(29443);
;// CONCATENATED MODULE: ./components/2022/plebiscito/RegionSection/SearchFilter.js

function SearchFilter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap:10px;\n    > * {\n        width: max-content;\n    }\n"
    ]);
    SearchFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n    margin-bottom: 2px;\n    @media(max-width: ",
        "){\n        font-size: 11px;\n        line-height: 15px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: contents;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: contents;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 70px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: end;\n    justify-content: space-between;\n    gap: 12px;\n    ",
        "{\n        display: contents;\n    }\n    ",
        "{\n        display: none;\n    }\n    @media(max-width: ",
        "){\n        flex-direction: column;\n        align-items: center;\n        ",
        "{\n            display: none;\n        }\n        ",
        "{\n            display: contents;\n        }\n        & ",
        "{\n            width: 70px;\n        }\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var SearchFilter = function(param) {
    var className = param.className, comparedElection = param.comparedElection, electionOptions = param.electionOptions, inputFilter = param.inputFilter, onChangeComparedElection = param.onChangeComparedElection, onChangeInputFilter = param.onChangeInputFilter, onChangeSelectedUnit = param.onChangeSelectedUnit, selectedUnit = param.selectedUnit;
    var regionInput = /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInput/* default */.ZP, {
        placeholder: "Filtrar por comuna",
        regionFilter: inputFilter,
        regionHandleChange: onChangeInputFilter
    });
    var comparedElectionWrapper = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparedElectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "COMPARAR"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparedElectionButton, {
                disabledOption: true,
                options: electionOptions.map(function(param) {
                    var electionKey = param.electionKey, label = param.label;
                    return {
                        key: electionKey,
                        label: label
                    };
                }),
                selectedOption: comparedElection,
                setSelectedOption: onChangeComparedElection
            })
        ]
    });
    var regularSearchFilter = /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegularSearchFilter, {
        children: [
            regionInput,
            comparedElectionWrapper,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(plebiscito_MultiSelectionButton, {
                options: [
                    {
                        key: "porcentaje",
                        label: "Porcentaje"
                    },
                    {
                        key: "cantidad",
                        label: "Cantidad"
                    }
                ],
                selectedOption: selectedUnit,
                setSelectedOption: onChangeSelectedUnit
            })
        ]
    });
    var mobileSearchFilter = /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSearchFilter, {
        children: [
            comparedElectionWrapper,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileBottomWrapper, {
                children: [
                    regionInput,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DatatypeSelector, {
                        options: [
                            {
                                key: "porcentaje",
                                label: "%"
                            },
                            {
                                key: "cantidad",
                                label: "N\xba"
                            }
                        ],
                        selectedOption: selectedUnit,
                        setSelectedOption: onChangeSelectedUnit
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchFilter_Wrapper, {
        className: className,
        children: [
            regularSearchFilter,
            mobileSearchFilter
        ]
    });
};
var ComparedElectionButton = (0,styled_components_browser_esm/* default */.ZP)(plebiscito_MultiSelectionButton).withConfig({
    componentId: "sc-5d45f1f0-0"
})(SearchFilter_templateObject());
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d45f1f0-1"
})(_templateObject1(), global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint);
var RegularSearchFilter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d45f1f0-2"
})(_templateObject2());
var MobileSearchFilter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d45f1f0-3"
})(_templateObject3());
var DatatypeSelector = (0,styled_components_browser_esm/* default */.ZP)(plebiscito_MultiSelectionButton).withConfig({
    componentId: "sc-5d45f1f0-4"
})(_templateObject4());
var MobileBottomWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d45f1f0-5"
})(_templateObject5());
var ComparedElectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d45f1f0-6"
})(_templateObject6());
var SearchFilter_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d45f1f0-7"
})(_templateObject7(), RegularSearchFilter, MobileSearchFilter, global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint, RegularSearchFilter, MobileSearchFilter, FilterInput/* InputStyled */.l_);
/* harmony default export */ var RegionSection_SearchFilter = (SearchFilter);


/***/ }),

/***/ 21660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ getTerritoryTableData; },
/* harmony export */   "De": function() { return /* binding */ ELECTIONS_TO_COMPARE; },
/* harmony export */   "EK": function() { return /* binding */ getTerritoriesResult; },
/* harmony export */   "_L": function() { return /* binding */ filterTable; },
/* harmony export */   "bW": function() { return /* binding */ sortTable; },
/* harmony export */   "jl": function() { return /* binding */ getAllData; },
/* harmony export */   "rm": function() { return /* binding */ sorterHandler; },
/* harmony export */   "sy": function() { return /* binding */ getZoneData; }
/* harmony export */ });
/* unused harmony exports getValue, normalizeText, getElectionsToRemove, formatPercentage, formatCantidad */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_2022_plebiscito_contextData_zonesMapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28629);
/* harmony import */ var components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25735);
/* harmony import */ var components_global_parameters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29443);
/* harmony import */ var _contextData_zonesData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2032);
/* harmony import */ var _Summary_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88304);










var sorterHandler = function(param) {
    var field = param.field, setSorter = param.setSorter, sorter = param.sorter;
    var changeOrder = sorter.field === field && sorter.order === "asc";
    var newOrder = changeOrder ? "desc" : "asc";
    setSorter({
        field: "".concat(field),
        order: newOrder
    });
};
var ELECTIONS_TO_COMPARE = [
    components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__/* .ELECTIONS_PROPERTIES.pEntrada */ .N5.pEntrada,
    components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__/* .ELECTIONS_PROPERTIES.sVuelta */ .N5.sVuelta
];
var getValue = function(object, path) {
    var value = lodash__WEBPACK_IMPORTED_MODULE_0___default().get(object, path);
    if (isNaN(value)) {
        return value;
    }
    return Number(value);
};
var normalizeText = function(str) {
    return str === null || str === void 0 ? void 0 : str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
var getElectionsToRemove = function(param) {
    var comparedElection = param.comparedElection;
    var comparedElections = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ELECTIONS_TO_COMPARE);
    var selectedElectionIndex = comparedElections.findIndex(function(election) {
        return election.electionKey === comparedElection;
    });
    selectedElectionIndex !== -1 && comparedElections.splice(selectedElectionIndex, 1);
    return comparedElections;
};
var formatPercentage = function(str) {
    var format = components_global_parameters__WEBPACK_IMPORTED_MODULE_3__/* .percentFormatter.format */ .yE.format;
    return format(str);
};
var formatCantidad = function(int) {
    return int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
var getTerritoriesResult = function(dataByTerritory) {
    var _electionKey = components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__/* .ELECTIONS_PROPERTIES */ .N5[dataByTerritory[0].electionKey], optionA = _electionKey.optionA, optionB = _electionKey.optionB, totalVotantes = _electionKey.totalVotantes;
    var stats = (0,_Summary_helpers__WEBPACK_IMPORTED_MODULE_5__/* .getVotesSummary */ .QB)({
        electionData: dataByTerritory,
        optionA: optionA,
        optionB: optionB,
        totalVotantes: totalVotantes
    });
    var colorA = stats.colorA, colorB = stats.colorB, ratioOptionA = stats.ratioOptionA, ratioOptionB = stats.ratioOptionB, totalOptionA = stats.totalOptionA, totalOptionB = stats.totalOptionB, totalValid = stats.totalValid;
    return {
        optionA: {
            cantidad: totalOptionA,
            color: colorA,
            porcentaje: ratioOptionA
        },
        optionB: {
            cantidad: totalOptionB,
            color: colorB,
            porcentaje: ratioOptionB
        },
        totalVotes: totalValid
    };
};
var resultsByelection = function(param) {
    var data = param.data;
    return data.map(function(param) {
        var electionsData = param.electionsData, regionKey = param.regionKey;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, components_2022_plebiscito_contextData_zonesMapping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].find */ .ZP.find(function(param) {
            var key = param.key;
            return key === regionKey;
        })), {
            results: Object.entries(electionsData).reduce(function(resultsByRegion, param) {
                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), key = _param[0], territories = _param[1];
                resultsByRegion[key] = getTerritoriesResult(territories);
                return resultsByRegion;
            }, {})
        });
    });
};
var sortTable = function(param) {
    var data = param.data, sorter = param.sorter;
    return data.sort(function(t1, t2) {
        var firstValue = getValue(t1, sorter.field);
        var secondValue = getValue(t2, sorter.field);
        var numberSorter = typeof firstValue === "number" && typeof secondValue === "number";
        var comparison = numberSorter ? Number.parseFloat(firstValue) - Number.parseFloat(secondValue) : String(firstValue).localeCompare(String(secondValue), undefined, {
            ignorePunctuation: true,
            numeric: true,
            sensitivity: "base",
            usage: "sort"
        });
        return sorter.order === "desc" ? -comparison : comparison;
    });
};
var formatters = {
    "cantidad": formatCantidad,
    "porcentaje": formatPercentage
};
var filterTable = function(param) {
    var comparedElection = param.comparedElection, data = param.data, inputFilter = param.inputFilter, selectedUnit = param.selectedUnit;
    var electionsToRemove = getElectionsToRemove({
        comparedElection: comparedElection
    });
    var zoneFilteredData = data.filter(function(t) {
        var ref;
        return (ref = normalizeText(t.label)) === null || ref === void 0 ? void 0 : ref.includes(normalizeText(inputFilter));
    });
    zoneFilteredData.forEach(function(t) {
        var formatter = formatters[selectedUnit];
        Object.values(electionsToRemove).forEach(function(param) {
            var electionKey = param.electionKey;
            return delete t.results[electionKey];
        });
        Object.values(t.results).forEach(function(r) {
            r.optionA.label = formatter(r.optionA[selectedUnit]);
            r.optionB.label = formatter(r.optionB[selectedUnit]);
        });
    });
    return zoneFilteredData;
};
var getAllData = function(param) {
    var pEntrada = param.pEntrada, pSalida = param.pSalida, sVuelta = param.sVuelta;
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(pSalida.nacional).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(pSalida.internacional)).map(function(t) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, t), {
            electionKey: components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__/* .ELECTIONS_PROPERTIES.pSalida.electionKey */ .N5.pSalida.electionKey
        });
    })).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(pEntrada.nacional).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(pEntrada.internacional)).map(function(t) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, t), {
            electionKey: components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__/* .ELECTIONS_PROPERTIES.pEntrada.electionKey */ .N5.pEntrada.electionKey
        });
    })), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(sVuelta.nacional).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(sVuelta.internacional)).map(function(t) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, t), {
            electionKey: components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__/* .ELECTIONS_PROPERTIES.sVuelta.electionKey */ .N5.sVuelta.electionKey
        });
    })));
};
var regionData = function(param) {
    var allElectionsData = param.allElectionsData;
    var dataByRegion = lodash__WEBPACK_IMPORTED_MODULE_0___default().groupBy(allElectionsData, function(param) {
        var N_KEY_REGION = param.N_KEY_REGION;
        return N_KEY_REGION || "t.r.extranjero";
    });
    delete dataByRegion["t.r.extranjero"];
    return dataByRegion;
};
var getZoneData = function(param) {
    var allElectionsData = param.allElectionsData;
    var zones = components_2022_plebiscito_contextData_zonesMapping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].filter */ .ZP.filter(function(z) {
        return z.isZone;
    });
    var dataByZone = zones.reduce(function(acc, zone) {
        acc[zone.key] = (0,components_2022_plebiscito_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getRegionCommunes */ .dT)({
            allElectionsData: allElectionsData,
            regionId: zone.key.replace("t.r.", ""),
            zones: _contextData_zonesData__WEBPACK_IMPORTED_MODULE_4__/* .zones */ .A
        });
        return acc;
    }, {});
    var extranjeroData = allElectionsData.filter(function(param) {
        var N_KEY_REGION = param.N_KEY_REGION;
        return !N_KEY_REGION;
    });
    dataByZone["t.r.extranjero"] = extranjeroData;
    return dataByZone;
};
var getTerritoryTableData = function(param) {
    var comparedElection = param.comparedElection, _getTerritoryData = param.getTerritoryData, getTerritoryData = _getTerritoryData === void 0 ? regionData : _getTerritoryData, inputFilter = param.inputFilter, pEntrada = param.pEntrada, pSalida = param.pSalida, selectedUnit = param.selectedUnit, sorter = param.sorter, sVuelta = param.sVuelta;
    var allElectionsData = getAllData({
        pEntrada: pEntrada,
        pSalida: pSalida,
        sVuelta: sVuelta
    });
    var dataByRegion = getTerritoryData({
        allElectionsData: allElectionsData
    });
    var dataByElection = Object.entries(dataByRegion).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), regionKey = _param[0], territories = _param[1];
        return {
            electionsData: lodash__WEBPACK_IMPORTED_MODULE_0___default().groupBy(territories, "electionKey"),
            regionKey: regionKey
        };
    });
    var results = resultsByelection({
        data: dataByElection
    });
    var sortedData = sortTable({
        data: results,
        sorter: sorter
    });
    var filteredData = filterTable({
        comparedElection: comparedElection,
        data: sortedData,
        inputFilter: inputFilter,
        selectedUnit: selectedUnit
    });
    return filteredData;
};


/***/ }),

/***/ 73122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ getTableData; },
  "r": function() { return /* binding */ sorterHandler; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/2022/plebiscito/[regionId]/Communes/RegionSection/Summary/helpers.js

var getElectionResults = function(param) {
    var electionData = param.electionData, label = param.label, mobileLabel = param.mobileLabel, optionA = param.optionA, optionB = param.optionB, shortLabel = param.shortLabel, totalVotantes = param.totalVotantes;
    var stats = getVotesSummary({
        electionData: electionData,
        optionA: optionA,
        optionB: optionB,
        totalVotantes: totalVotantes
    });
    var padron = stats.padron, total = stats.total, totalOptionA = stats.totalOptionA, totalOptionB = stats.totalOptionB, totalValid = stats.totalValid;
    var results = {
        label: label,
        mobileLabel: mobileLabel,
        options: [
            {
                cantidad: totalOptionA,
                color: optionA.color,
                label: optionA.shortLabel || optionA.label,
                porcentaje: totalOptionA / totalValid
            },
            {
                cantidad: totalOptionB,
                color: optionB.color,
                label: optionB.shortLabel || optionB.label,
                porcentaje: totalOptionB / totalValid
            }
        ],
        participation: {
            cantidad: total,
            porcentaje: total / padron,
            totalVotes: padron
        },
        shortLabel: shortLabel || label,
        totalVotes: totalValid
    };
    results.options.sort(function(a, b) {
        return b.cantidad - a.cantidad;
    });
    return results;
};
var getVotesSummary = function(param) {
    var electionData = param.electionData, optionA = param.optionA, optionB = param.optionB, totalVotantes = param.totalVotantes;
    var totalOptionA = lodash_default().sumBy(electionData, function(territory) {
        return territory[optionA.field] || 0;
    });
    var totalOptionB = lodash_default().sumBy(electionData, function(territory) {
        return territory[optionB.field] || 0;
    });
    var totalBlank = lodash_default().sumBy(electionData, function(territory) {
        return territory.BLANCO || 0;
    });
    var totalNull = lodash_default().sumBy(electionData, function(territory) {
        return territory.NULO || 0;
    });
    var padron = lodash_default().sumBy(electionData, function(territory) {
        return territory[totalVotantes] || 0;
    });
    var totalValid = totalOptionA + totalOptionB;
    var total = totalValid + totalBlank + totalNull;
    var participation = total / padron;
    return {
        padron: padron,
        participation: participation,
        total: total,
        totalBlank: totalBlank,
        totalNull: totalNull,
        totalOptionA: totalOptionA,
        totalOptionB: totalOptionB,
        totalValid: totalValid
    };
};

// EXTERNAL MODULE: ./components/2022/plebiscito/AtDecideChile.js
var AtDecideChile = __webpack_require__(67171);
// EXTERNAL MODULE: ./components/2022/plebiscito/helpers.js
var helpers = __webpack_require__(25735);
// EXTERNAL MODULE: ./components/2022/plebiscito/Summary/index.js
var Summary = __webpack_require__(88848);
// EXTERNAL MODULE: ./components/2022/plebiscito/Summary/ElectionBarVerbose/index.js + 2 modules
var ElectionBarVerbose = __webpack_require__(46751);
// EXTERNAL MODULE: ./components/2022/plebiscito/Summary/helpers.js
var Summary_helpers = __webpack_require__(88304);
// EXTERNAL MODULE: ./components/2022/plebiscito/Summary/Participation/index.js + 1 modules
var Participation = __webpack_require__(1288);
// EXTERNAL MODULE: ./components/2022/plebiscito/Summary/ScrutinyProgress.js
var ScrutinyProgress = __webpack_require__(16072);
// EXTERNAL MODULE: ./components/2022/plebiscito/TitleHeader.js
var TitleHeader = __webpack_require__(54761);
// EXTERNAL MODULE: ./components/Environment.js
var Environment = __webpack_require__(63458);
// EXTERNAL MODULE: ./components/global-parameters.js
var global_parameters = __webpack_require__(29443);
;// CONCATENATED MODULE: ./components/2022/plebiscito/[regionId]/Communes/RegionSection/Summary/index.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: ",
        ";\n  border: 2px solid ",
        ";\n  @media(max-width: ",
        "){\n    position: sticky;\n    left: 0;\n    width: calc(100vw - ",
        " - ",
        ");\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: capitalize;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














function Summary_Summary(param) {
    var communeKey = param.communeKey, communeName = param.communeName;
    var ref = (0,Environment/* useEnvironment */.O7)(), current = ref.current, _electionsData = ref.electionsData, pEntrada = _electionsData.pEntrada, pSalida = _electionsData.pSalida, sVuelta = _electionsData.sVuelta;
    var ref1 = (0,react.useState)("pEntradaSummary"), selectedOptionPEntrada = ref1[0], setSelectedOptionPEntrada = ref1[1];
    var ref2 = (0,react.useState)(), selectedOptionSVuelta = ref2[0], setSelectedOptionSVuelta = ref2[1];
    if (!pSalida || !pEntrada || !sVuelta) return "loading..." //TODO Loading component
    ;
    var pSalidaSummary = (0,_object_spread/* default */.Z)({}, getElectionResults((0,_object_spread/* default */.Z)({
        electionData: (0,_to_consumable_array/* default */.Z)(pSalida.nacional.filter(function(t) {
            return t.N_KEY === communeKey;
        }))
    }, helpers/* ELECTIONS_PROPERTIES.pSalida */.N5.pSalida)));
    var pEntradaSummary = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getElectionResults((0,_object_spread/* default */.Z)({
        electionData: (0,_to_consumable_array/* default */.Z)(pEntrada.nacional.filter(function(t) {
            return t.N_KEY === communeKey;
        }))
    }, helpers/* ELECTIONS_PROPERTIES.pEntrada */.N5.pEntrada))), {
        selectedOption: selectedOptionPEntrada,
        setSelectedOption: setSelectedOptionPEntrada
    });
    var sVueltaSummary = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getElectionResults((0,_object_spread/* default */.Z)({
        electionData: (0,_to_consumable_array/* default */.Z)(sVuelta.nacional.filter(function(t) {
            return t.N_KEY === communeKey;
        }))
    }, helpers/* ELECTIONS_PROPERTIES.sVuelta */.N5.sVuelta))), {
        selectedOption: selectedOptionSVuelta,
        setSelectedOption: setSelectedOptionSVuelta
    });
    var options = {
        pEntradaSummary: pEntradaSummary,
        sVueltaSummary: sVueltaSummary
    };
    var summaryData = (0,Summary_helpers/* getSummaryData */.ss)(options);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Top, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrutinyProgress/* default */.Z, {
                        updatedAt: current.updated_at
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary_TitleHeader, {
                        children: communeName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary/* ComparativeButton */.dG, {
                        options: summaryData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AtDecideChile/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary/* Results */.u9, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectionBarVerbose/* default */.ZP, {
                        comparedOptions: summaryData,
                        salida: pSalidaSummary
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Participation/* default */.ZP, {
                        comparedOptions: summaryData,
                        salida: pSalidaSummary
                    })
                ]
            })
        ]
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35661abb-0"
})(_templateObject(), global_parameters/* spaces.m */.RZ.m, global_parameters/* colors.colorRed1 */.O9.colorRed1, global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint, global_parameters/* spaces.m */.RZ.m, global_parameters/* spaces.m */.RZ.m);
var Top = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35661abb-1"
})(_templateObject1(), global_parameters/* spaces.xs */.RZ.xs);
var Summary_TitleHeader = (0,styled_components_browser_esm/* default */.ZP)(TitleHeader/* default */.ZP).withConfig({
    componentId: "sc-35661abb-2"
})(_templateObject2());

// EXTERNAL MODULE: ./components/2022/plebiscito/contextData/territories.js
var territories = __webpack_require__(37269);
// EXTERNAL MODULE: ./components/2022/plebiscito/contextData/zonesData.js
var zonesData = __webpack_require__(2032);
// EXTERNAL MODULE: ./components/2022/plebiscito/RegionSection/helpers.js
var RegionSection_helpers = __webpack_require__(21660);
;// CONCATENATED MODULE: ./components/2022/plebiscito/[regionId]/Communes/RegionSection/helpers.js










var sorterHandler = function(param) {
    var field = param.field, setSorter = param.setSorter, sorter = param.sorter;
    var newField = "order" === field ? "label" : field;
    (0,RegionSection_helpers/* sorterHandler */.rm)({
        field: newField,
        setSorter: setSorter,
        sorter: sorter
    });
};
var getTableData = function(param) {
    var comparedElection = param.comparedElection, inputFilter = param.inputFilter, pEntrada = param.pEntrada, pSalida = param.pSalida, regionId = param.regionId, selectedCommune = param.selectedCommune, selectedUnit = param.selectedUnit, setSelectedCommune = param.setSelectedCommune, sorter = param.sorter, sortTable = param.sortTable, sVuelta = param.sVuelta;
    var allElectionsData = (0,RegionSection_helpers/* getAllData */.jl)({
        pEntrada: pEntrada,
        pSalida: pSalida,
        sVuelta: sVuelta
    });
    var regionData = (0,helpers/* getRegionCommunes */.dT)({
        allElectionsData: allElectionsData,
        regionId: regionId,
        zones: zonesData/* zones */.A
    });
    var communes = lodash_default().uniqBy(regionData, "N_KEY");
    var dataByElection = lodash_default().groupBy(regionData, "electionKey");
    var results = communes.map(function(commune) {
        var ref;
        var communeResults = Object.entries(dataByElection).reduce(function(results, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), electionKey = _param[0], communes = _param[1];
            var selectedCommune = communes.find(function(c) {
                return c.N_KEY === commune.N_KEY;
            });
            results[electionKey] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,RegionSection_helpers/* getTerritoriesResult */.EK)([
                selectedCommune
            ])), {
                communeData: commune
            });
            return results;
        }, {});
        var communeName = (ref = territories/* default.find */.Z.find(function(territory) {
            return territory.n_key_comuna === commune.N_KEY;
        })) === null || ref === void 0 ? void 0 : ref.label.toLowerCase();
        var isCommuneSelected = commune.N_KEY === selectedCommune;
        return {
            key: commune.N_KEY.toLowerCase(),
            label: communeName,
            onClick: function() {
                return setSelectedCommune(isCommuneSelected ? "" : commune.N_KEY);
            },
            results: communeResults,
            rowItem: /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary_Summary, {
                communeKey: commune.N_KEY,
                communeName: communeName
            })
        };
    }, {});
    var selectedCommuneData = results.find(function(t) {
        return t.key === selectedCommune;
    });
    if (selectedCommuneData) {
        selectedCommuneData.selected = true;
    }
    var sortedData = sortTable({
        data: results,
        sorter: sorter
    });
    var filteredData = (0,RegionSection_helpers/* filterTable */._L)({
        comparedElection: comparedElection,
        data: sortedData,
        inputFilter: inputFilter,
        selectedUnit: selectedUnit
    });
    return filteredData;
};


/***/ }),

/***/ 2032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ zones; }
/* harmony export */ });
var zones = {
    "granconcepcion": [
        "t.c.concepcion",
        "t.c.talcahuano",
        "t.c.coronel",
        "t.c.hualqui",
        "t.c.penco",
        "t.c.lota",
        "t.c.tome",
        "t.c.sanpedrodelapaz",
        "t.c.ghiguayante",
        "t.c.hualpen"
    ],
    "gransantiago": [
        "t.c.cerrillos",
        "t.c.cerronavia",
        "t.c.conchali",
        "t.c.elbosque",
        "t.c.estacioncentral",
        "t.c.huechuraba",
        "t.c.independencia",
        "t.c.lacisterna",
        "t.c.laflorida",
        "t.c.lagranja",
        "t.c.lapintana",
        "t.c.lareina",
        "t.c.lascondes",
        "t.c.lobarnechea",
        "t.c.loespejo",
        "t.c.loprado",
        "t.c.macul",
        "t.c.maipu",
        "t.c.nunoa",
        "t.c.pedroaguirrecerda",
        "t.c.penanolen",
        "t.c.providencia",
        "t.c.pudahuel",
        "t.c.puentealto",
        "t.c.quilicura",
        "t.c.quintanormal",
        "t.c.recoleta",
        "t.c.renca",
        "t.c.sanbernardo",
        "t.c.sanjoaquin",
        "t.c.sanmiguel",
        "t.c.sanramon",
        "t.c.santiago",
        "t.c.vitacura", 
    ],
    "granvalparaiso": [
        "t.c.valparaiso",
        "t.c.vinadelmar",
        "t.c.concon",
        "t.c.quilpue",
        "t.c.villaalemana"
    ]
};


/***/ }),

/***/ 28629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports zonesMapping, territoryMatch */
var zonesMapping = [
    {
        acronym: "AP",
        href: "/region/dearicayparinacota",
        icon: "/images/territories/arica_y_parinacota.svg",
        key: "t.r.dearicayparinacota",
        label: "Arica y Parinacota",
        order: 1,
        shortLabel: "Arica y Parinacota"
    },
    {
        acronym: "TA",
        href: "/region/detarapaca",
        icon: "/images/territories/tarapaca.svg",
        key: "t.r.detarapaca",
        label: "Tarapac\xe1",
        order: 2,
        shortLabel: "Tarapac\xe1"
    },
    {
        acronym: "AN",
        href: "/region/deantofagasta",
        icon: "/images/territories/antofagasta.svg",
        key: "t.r.deantofagasta",
        label: "Antofagasta",
        order: 3,
        shortLabel: "Antofagasta"
    },
    {
        acronym: "AT",
        href: "/region/deatacama",
        icon: "/images/territories/atacama.svg",
        key: "t.r.deatacama",
        label: "Atacama",
        order: 4,
        shortLabel: "Atacama"
    },
    {
        acronym: "CO",
        href: "/region/decoquimbo",
        icon: "/images/territories/coquimbo.svg",
        key: "t.r.decoquimbo",
        label: "Coquimbo",
        order: 5,
        shortLabel: "Coquimbo"
    },
    {
        acronym: "VA",
        href: "/region/devalparaiso",
        icon: "/images/territories/valparaiso.svg",
        key: "t.r.devalparaiso",
        label: "Valpara\xedso",
        order: 6,
        shortLabel: "Valpara\xedso"
    },
    {
        acronym: "RM",
        href: "/region/metropolitanadesantiago",
        icon: "/images/territories/metropolitana.svg",
        key: "t.r.metropolitanadesantiago",
        label: "Metropolitana",
        order: 7,
        shortLabel: "Metropolitana"
    },
    {
        acronym: "OH",
        href: "/region/dellibertadorgeneralbernardoohiggins",
        icon: "/images/territories/ohiggins.svg",
        key: "t.r.dellibertadorgeneralbernardoohiggins",
        label: "Libertador General Bernardo O’Higgins",
        order: 8,
        shortLabel: "O’Higgins"
    },
    {
        acronym: "ML",
        href: "/region/delmaule",
        icon: "/images/territories/maule.svg",
        key: "t.r.delmaule",
        label: "Maule",
        order: 9,
        shortLabel: "Maule"
    },
    {
        acronym: "\xd1B",
        href: "/region/denuble",
        icon: "/images/territories/nuble.svg",
        key: "t.r.denuble",
        label: "\xd1uble",
        order: 10,
        shortLabel: "\xd1uble"
    },
    {
        acronym: "BI",
        href: "/region/delbiobio",
        icon: "/images/territories/biobio.svg",
        key: "t.r.delbiobio",
        label: "Biob\xedo",
        order: 11,
        shortLabel: "Biob\xedo"
    },
    {
        acronym: "AR",
        href: "/region/delaaraucania",
        icon: "/images/territories/la_araucania.svg",
        key: "t.r.delaaraucania",
        label: "La Araucan\xeda",
        order: 12,
        shortLabel: "La Araucan\xeda"
    },
    {
        acronym: "LR",
        href: "/region/delosrios",
        icon: "/images/territories/los_rios.svg",
        key: "t.r.delosrios",
        label: "Los R\xedos",
        order: 13,
        shortLabel: "Los R\xedos"
    },
    {
        acronym: "LL",
        href: "/region/deloslagos",
        icon: "/images/territories/los_lagos.svg",
        key: "t.r.deloslagos",
        label: "Los Lagos",
        order: 14,
        shortLabel: "Los Lagos"
    },
    {
        acronym: "AI",
        href: "/region/deaysendelgeneralcarlosibanezdelcampo",
        icon: "/images/territories/aysen.svg",
        key: "t.r.deaysendelgeneralcarlosibanezdelcampo",
        label: "Ays\xe9n del General Carlos Ib\xe1nez del Campo",
        order: 15,
        shortLabel: "Ays\xe9n"
    },
    {
        acronym: "MA",
        href: "/region/demagallanesydelaantarticachilena",
        icon: "/images/territories/magallanes_y_ach.svg",
        key: "t.r.demagallanesydelaantarticachilena",
        label: "Magallanes y de la Ant\xe1rtica Chilena",
        order: 16,
        shortLabel: "Magallanes y ACh."
    },
    {
        href: "/region/granvalparaiso",
        icon: "/images/territories/granvalparaiso.svg",
        isZone: true,
        key: "t.r.granvalparaiso",
        label: "Gran Valpara\xedso",
        order: 18,
        shortLabel: "Gran Valpara\xedso"
    },
    {
        href: "/region/gransantiago",
        icon: "/images/territories/gransantiago.svg",
        isZone: true,
        key: "t.r.gransantiago",
        label: "Gran Santiago",
        order: 19,
        shortLabel: "Gran Santiago"
    },
    {
        href: "/region/granconcepcion",
        icon: "/images/territories/granconcepcion.svg",
        isZone: true,
        key: "t.r.granconcepcion",
        label: "Gran Concepci\xf3n",
        order: 20,
        shortLabel: "Gran Concepci\xf3n"
    },
    {
        href: "/region/macrozonasur",
        icon: "/images/territories/macrozonasur.svg",
        isZone: true,
        key: "t.r.macrozonasur",
        label: "Macrozona Sur",
        order: 21,
        shortLabel: "Macrozona Sur"
    },
    {
        href: "/extranjero",
        icon: "/images/territories/extranjero.svg",
        isZone: true,
        key: "t.r.extranjero",
        label: "Extranjero",
        order: 22,
        shortLabel: "Extranjero"
    }, 
];
var territoryMatch = function(territory) {
    return zonesMapping.find(function(item) {
        return item.key === territory;
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (zonesMapping);


/***/ })

}]);